import React from "react";
import {ScrollView} from "react-native";
import MainStyle from "../../../MainStyle";
import Div from "../../lib/Div";
import {TermsTextProvider} from "./TermsText";
import IntroductionSection from "./sections/IntroductionSection";
import OrderChallengeRefundSection from "./sections/OrderChallengeRefundSection";
import ParticipationEligibilitySection from "./sections/ParticipationEligibilitySection";
import ParticipationConductSection from "./sections/ParticipationConductSection";
import ChallengePrizesSection from "./sections/ChallengePrizesSection";
import WarrantySection from "./sections/WarrantySection";
import LiabilitySection from "./sections/LiabilitySection";
import IntellectualPropertySection from "./sections/IntellectualPropertySection";
import PrivacyForceSection from "./sections/PrivacyForceSection";
import GoverningDisputeSection from "./sections/GoverningDisputeSection";
import ClosingTermsSection from "./sections/ClosingTermsSection";
import SmsSection from "./sections/SmsSection";
import MessagingTermsSection from "./sections/MessagingTermsSection";

type Props = { bg?: string, height?: number, maxHeight?: number, px?: number, pb?: number };

const TermsAndConditionsContent = ({bg, height, maxHeight, px, pb}: Props) => {
  return (
    <TermsTextProvider>
      <ScrollView keyboardShouldPersistTaps="handled"
                  contentContainerStyle={[MainStyle.min_h_full, {
                    backgroundColor: bg, height, maxHeight, paddingHorizontal: px
                  }]}>
        <Div maxW={1120} mx="auto" pb={pb}>
          <IntroductionSection/>
          <OrderChallengeRefundSection/>
          <ParticipationEligibilitySection/>
          <ParticipationConductSection/>
          <ChallengePrizesSection/>
          <WarrantySection/>
          <LiabilitySection/>
          <IntellectualPropertySection/>
          <PrivacyForceSection/>
          <GoverningDisputeSection/>
          <ClosingTermsSection/>
          <SmsSection/>
          <MessagingTermsSection/>
        </Div>
      </ScrollView>
    </TermsTextProvider>
  );
};

export default React.memo(TermsAndConditionsContent);
